const APP_NAME = "Youth Empowerment App";
const APP_VERSION = "1.9.50";
const APP_VERSION_CODE = 70;
const API_BASE_URL = "https://yc.intuitlms.online/api";

const SCREEN_NAMES = {
  HOME: "Home",
  LOGIN: "Login",
  REGISTER: "Register",
  EVENTS: "Events",
  CHAT: "Chat",
  PESA: "Finance",
  SOMA: "Learning",
  PROFILE: "Profile",
};

const EVENT_TYPES = {
  WORKSHOP: "Workshop",
  SEMINAR: "Seminar",
  MEETUP: "Meetup",
};

const FINANCE_TOPICS = {
  BUDGETING: "Budgeting",
  SAVINGS: "Savings",
  INVESTING: "Investing",
};

const SPIRITUAL_TOPICS = {
  DEVOTIONAL: "Devotional",
  MEDITATION: "Meditation",
  COMMUNITY_SERVICE: "Community Service",
};

export {
  APP_NAME,
  APP_VERSION,
  APP_VERSION_CODE,
  API_BASE_URL,
  SCREEN_NAMES,
  EVENT_TYPES,
  FINANCE_TOPICS,
  SPIRITUAL_TOPICS,
};
